import uqnSplit from '../functions/uqnSplit';
export default function check(uqn) {
    if (uqn < 100000 || uqn > 399999) {
        return false;
    }
    else {
        let [t, i, a, b, c, s] = uqnSplit(uqn);
        if (t == 1) {
            if (i > 6) {
                return false;
            }
            if (a == 0 || c == 0) {
                return false;
            }
            if (i < 5) {
                if (b == 0) {
                    return false;
                }
                if (i == 4) {
                    if (s > 3 || 4 * b == a * a) {
                        return false;
                    }
                }
                else {
                    if (s != 0) {
                        return false;
                    }
                }
            }
            else {
                if (b != 0 || s != 0) {
                    return false;
                }
            }
        }
        else if (t == 2) {
            if (i > 6) {
                return false;
            }
            if (a == 0 || c == 0) {
                return false;
            }
            if (i == 0) {
                if (s != 0 || b == 0) {
                    return false;
                }
            }
            else if (i < 3) {
                if (b == 0 || s > 2) {
                    return false;
                }
            }
            else if (i < 5) {
                if (b == 0 || s != 0) {
                    return false;
                }
            }
            else if (i == 5) {
                if (b == 0 || s > 3) {
                    return false;
                }
                if (b * 4 == a * a) {
                    return false;
                }
            }
            else if (i == 6) {
                if (b != 0 || s != 0) {
                    return false;
                }
            }
        }
        else if (t == 3) {
            if (i > 4 || a == 0 || b == 0 || c == 0 || s > 7) {
                return false;
            }
        }
    }
    return true;
}
